import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUpload } from "react-icons/fa";
import { MdPersonAdd } from "react-icons/md";
import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const roles = ["Admin", "Editor", "Viewer"];

const AddUser = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    avatar: "",
  });
  const [imagePreview, setImagePreview] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setImagePreview(url);
      setForm({ ...form, avatar: url });
    } else {
      setImagePreview("");
      setForm({ ...form, avatar: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password || !form.role) {
      setError("All fields are required.");
      return;
    }
    try {
      await addDoc(collection(db, "users"), {
        name: form.name,
        email: form.email,
        role: form.role,
        avatar: form.avatar || "",
        status: "Active",
        lastLogin: "Never",
        createdAt: serverTimestamp(),
      });
      navigate("/");
    } catch (err) {
      setError("Failed to add user. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-8 px-2 sm:px-4 md:px-8 ">
      <div className="w-full max-w-4xl bg-white rounded-3xl shadow-2xl p-8 animate-slideInRight">
        <h2 className="text-2xl font-bold mb-6 text-gray-900 text-center">Add New User</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700 mb-1">Avatar</label>
            <label htmlFor="avatar-upload" className="flex flex-col items-center justify-center border-2 border-dashed border-orange rounded-xl p-4 cursor-pointer hover:border-orange2 transition group bg-orange/5">
              <FaUpload className="text-2xl text-orange group-hover:text-orange2 mb-2" />
              <span className="text-xs text-orange group-hover:text-orange2">Click to upload or drag & drop</span>
              <input id="avatar-upload" type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
            </label>
            {imagePreview && (
              <div className="flex flex-col items-center mt-2">
                <img src={imagePreview} alt="Preview" className="w-20 h-20 object-cover rounded-full border-2 border-orange2 shadow-lg mb-1" />
                <span className="text-xs text-gray-400">Preview</span>
              </div>
            )}
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Name</label>
            <input name="name" value={form.name} onChange={handleFormChange} className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2" required />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Email</label>
            <input name="email" type="email" value={form.email} onChange={handleFormChange} className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2" required />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Password</label>
            <input name="password" type="password" value={form.password} onChange={handleFormChange} className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2" required />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Role</label>
            <select name="role" value={form.role} onChange={handleFormChange} className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2 bg-white text-gray-700 font-semibold appearance-none transition-all duration-150 shadow-sm hover:border-orange2 focus:outline-none" required>
              <option value="" disabled>Choose Role</option>
              {roles.map((role) => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>
          {error && <div className="text-red-600 text-sm font-medium">{error}</div>}
          <button type="submit" className="mt-2 py-2 rounded-xl bg-orange2 text-white font-bold hover:bg-orange transition">
            <MdPersonAdd className="inline-block mr-2 mb-0.5 text-lg align-text-bottom" /> Add User
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddUser; 